import { SettingsForm, SettingsFormProps } from './SettingsForm';
import { useHpaSelectedSettingName } from '../../hpaSelectedSettingNameContexts';

type Props = Omit<SettingsFormProps, 'isDefault'>;
export const HpaSettingsForm = ({ ...props }: Props) => {
  const { useSettingIsDefault, settingName } = useHpaSelectedSettingName();

  const isDefault = useSettingIsDefault(settingName);

  return <SettingsForm {...props} isDefault={!!isDefault} />;
};
